import PropTypes from 'prop-types';
import React from 'react';
import styles from './BottomBackground.module.css';
export default function BottomBackground(_a) {
    var width = _a.width, backgroundColor = _a.backgroundColor;
    return (React.createElement("div", { className: styles.bottomBackground },
        React.createElement("div", { className: styles.inner, style: { backgroundColor: backgroundColor, width: width } })));
}
BottomBackground.propTypes = {
    width: PropTypes.number,
    backgroundColor: PropTypes.string,
};
